import staticConfig from "./staticConfig";
// const dmi = 'http://122.112.206.159:8082' || '//dmi.datatellit.com'
// const ds = 'http://122.112.206.159:8083' || '//dataservice.datatellit.com'
// const iot = 'http://122.112.206.159:8081' || '//iot.datatellit.com'

const dmi = window.statics.dmi;
const ds = window.statics.ds;
const iot = window.statics.iot;
const service = window.statics.service;
const otherControl = "https://business.alm-iot.com";
const dmi_localhost = window.statics.dmi_localhost;
const zzt = "//zeocor.z-things.com:1900";
export default {
  name: "智慧环境中控系统",
  dmi,
  ds,
  iot,
  staticConfig,
  api: {
    login: `${dmi}/users/login`,
    faceLogin: `${dmi}/teachers/login`,
    zone: `${dmi}/zoneusers/getzonebyparams`,
    zoneTree: `${dmi}/zones/:zoneId/tree`,
    subject: `${dmi}/subjectschedules/getsubjectbyzoneId/:zoneId`,
    scene: `${dmi}/zones/:zoneId/scene`,
    sceneVisible: `${dmi}/zones/:zoneId/scenes/visible`,
    notify: `${dmi}/schoolnotices/getnoticebyzoneId/:zoneId`,
    device: `${dmi}/zonedevices/getalldevicebyzoneid/:zoneId`,
    light: `${dmi}/zones/:zoneId/devices/deviceNodes`,
    extDevice: `${dmi}/zones/:zoneId/devices/extDevices`,
    config: `${dmi}/systemconfigs/`,
    // weather: `${dmi}/zones/weather/:zoneId`,
    weather: `${service}/open/weather`, // 使用新的天气接口
    sensor: `${dmi}/devices/state`,
    activeScene: `${dmi}/scenes/:sceneId/active`,
    socket: `${ds}/event`,
    control: `${iot}/dcioperates`,
    systemConfig: `${dmi}/systemconfigs`,
    report: `${dmi}/usersoperates`,
    scenes: `${dmi}/scenes`,
    zoneConfig: `${dmi}/zoneconfigs`,
    nodes: `${dmi}/devicenodes`,
    extDevices: `${dmi}/extdevices`,
    otherExtDevice: `${dmi}/zones/:zoneId/devices/otherDevices`,
    otherDeviceToken: `${dmi}/otherExtDevices/token`,
    status: `${dmi}/devices/status`,
    otherControl: `${otherControl}/sendDevCommandOfDevMeter`,
    otherExtState: `${otherControl}/getDevMeterCurrentData`,
    lockControl: `${zzt}/lock/control`,
    lockState: `${ds}/lock/state`,
  },
  defaultState: {
    aircon: { air: 1, mode: 0, state: 0, tt: 26 },
    airpure: { state: 0, air: 2 },
    curtain: { state: 0 },
    fan: { state: 0, air: 2 },
    colorbar: { state: 0, color: "white" },
    switch: { state: 0 },
    remote: {},
    sensor: {},
    airswitch: {},
  },
  v1: "http://boardv1.datatellit.com",
  assetsHost: dmi,
  monitor: [
    {
      no: "szsy/0002",
      src: [
        "rtmp://33525.liveplay.myqcloud.com/live/33525_24a3305891",
        "//33525.liveplay.myqcloud.com/live/33525_24a3305891.flv",
        "//33525.liveplay.myqcloud.com/live/33525_24a3305891.m3u8",
      ],
    },
  ],
  timing: 2000,
};
